var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVehicleProgressIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H13L20 4V20H7L0 16V0Z",
  fill: "#A2C3F9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.99937 6.25C7.9283 6.25 6.24937 7.92893 6.24937 10C6.24937 10.1023 6.25345 10.2036 6.26146 10.3038L6.87778 9.51492L7.66579 10.1306L6.35981 11.8022C6.1898 12.0198 5.87558 12.0583 5.65798 11.8883L3.98633 10.5824L4.60197 9.79434L5.2592 10.3078C5.25267 10.206 5.24937 10.1034 5.24937 10C5.24937 7.37665 7.37601 5.25 9.99937 5.25C11.4507 5.25 12.7504 5.90153 13.6209 6.92629L12.8588 7.57371C12.1702 6.76306 11.1449 6.25 9.99937 6.25Z",
  fill: "#004ECC"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7395 9.69214L15.3967 10.2056L16.0124 9.41757L14.3408 8.1116C14.1232 7.9416 13.8089 7.98018 13.6389 8.19778L12.3329 9.86936L13.1209 10.485L13.7373 9.69618C13.7453 9.79633 13.7494 9.89765 13.7494 10C13.7494 12.0711 12.0704 13.75 9.99937 13.75C8.8538 13.75 7.82858 13.2369 7.13995 12.4263L6.37781 13.0737C7.24832 14.0985 8.54801 14.75 9.99937 14.75C12.6227 14.75 14.7494 12.6234 14.7494 10C14.7494 9.89662 14.7461 9.79397 14.7395 9.69214Z",
  fill: "#004ECC"
})));
export { SvgVehicleProgressIcon as ReactComponent };
export default __webpack_public_path__ + "assets/a5c04cbc.svg";